var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-t bg-white overflow-auto py-4 rounded shadow"},[_c('div',{staticClass:"font-semibold text-l mx-4 mb-4 text-gray-500"},[_vm._v("Foot fall")]),_c('div',{staticClass:"px-2"},[_c('canvas',{attrs:{"id":"foot_fall"}})])])
}]

export { render, staticRenderFns }